import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CustomPropTypes from '../../util/custom-prop-types';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
import { DividerMixin } from '../../mixins/components/DividerMixin';
import { DIVIDER_APPEARANCES, DIVIDER_LENGTHS } from '../../constants/DIVIDER';
import { ORIENTATIONS } from '../../constants/ORIENTATIONS';
export var StyledDivider = /*#__PURE__*/styled('div').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['orientation'])
}).withConfig({
  displayName: "StyledDivider",
  componentId: "c11n-8-64-0__sc-oclvq-0"
})(["", ""], DividerMixin);
/**
 * Dividers are simple, linear components that can be used to visually separate content
 * and establish logical grouping.
 *
 * @since 8.38.0
 */

var Divider = function Divider(props) {
  return /*#__PURE__*/React.createElement(StyledDivider, props);
};

Divider.displayName = 'Divider';
Divider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The appearance of a divider.
   */
  appearance: PropTypes.oneOf(Object.keys(DIVIDER_APPEARANCES)),

  /**
   * The length of a divider.
   *
   * Supports [inline media query objects](#/Media%20queries)
   */
  length: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(Object.keys(DIVIDER_LENGTHS))),

  /**
   * The orientation of a divider.
   *
   * Supports [inline media query objects](#/Media%20queries)
   */
  orientation: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(Object.keys(ORIENTATIONS))),

  /**
   * A [role](https://www.w3.org/TR/wai-aria-1.2/#roles) is required for assistive
   * technologies to announce the divider properly. Divider uses the
   * [separator](https://www.w3.org/TR/wai-aria-1.2/#separator) role.
   */
  role: PropTypes.string
} : {};
Divider.defaultProps = {
  appearance: DIVIDER_APPEARANCES.regular,
  length: DIVIDER_LENGTHS.auto,
  orientation: ORIENTATIONS.horizontal,
  role: 'separator'
};
/** @component */

export default Divider;